<template>
  <div class="evidence-photo">
    <button class="evidence-photo-preview" type="button" :aria-label="previewLabel" @click="openPreview">
      <img v-if="imageUrl" :src="imageUrl" :alt="photoLabel" />
      <span v-else class="evidence-photo-placeholder">
        <i :class="loading ? 'el-icon-loading' : error ? 'el-icon-refresh' : 'el-icon-picture-outline'" aria-hidden="true" />
        <small>{{ loading ? (localeState.locale === 'en' ? 'Loading' : $t('加载中')) : error ? (localeState.locale === 'en' ? 'Retry' : $t('重试加载')) : (localeState.locale === 'en' ? 'Photo' : $t('照片')) }}</small>
      </span>
      <span class="evidence-photo-label">{{ photoLabel }}</span>
    </button>
    <button v-if="removable" class="evidence-photo-remove" type="button" :aria-label="removeLabel" :title="removeLabel" @click="$emit('remove', id)">×</button>
  </div>
</template>

<script>
import { getEvidence } from '@/api/transport'
import { localeState } from '@/i18n'

export default {
  name: 'EvidencePhoto',
  props: {
    id: { type: [String, Number], required: true },
    admin: { type: Boolean, required: true },
    index: { type: Number, required: true },
    removable: { type: Boolean, default: false }
  },
  data () { return { imageUrl: '', loading: false, error: false, localeState } },
  computed: {
    photoLabel () { return `${this.localeState.locale === 'en' ? 'Photo' : '照片'} ${this.index}` },
    previewLabel () { return `${this.localeState.locale === 'en' ? 'Preview' : '预览'}${this.localeState.locale === 'en' ? ' ' : ''}${this.photoLabel}` },
    removeLabel () { return `${this.localeState.locale === 'en' ? 'Remove' : '移除'}${this.localeState.locale === 'en' ? ' ' : ''}${this.photoLabel}` }
  },
  created () { this.disposed = false },
  mounted () { this.loadImage() },
  beforeDestroy () { this.disposed = true; this.releaseImage() },
  methods: {
    releaseImage () {
      if (this.imageUrl) URL.revokeObjectURL(this.imageUrl)
      this.imageUrl = ''
    },
    async loadImage () {
      if (this.loading) return
      this.loading = true
      this.error = false
      try {
        const blob = await getEvidence(this.admin, this.id)
        if (!blob || !blob.type.startsWith('image/')) throw new Error('照片格式不正确')
        if (this.disposed) return
        this.releaseImage()
        this.imageUrl = URL.createObjectURL(blob)
      } catch {
        if (!this.disposed) this.error = true
      } finally {
        if (!this.disposed) this.loading = false
      }
    },
    openPreview () {
      if (this.error) this.loadImage()
      else this.$emit('preview', this.id)
    }
  }
}
</script>

<style scoped>
.evidence-photo { position: relative; flex: none; width: 120px; }
.evidence-photo-preview { display: flex; flex-direction: column; width: 120px; height: 120px; overflow: hidden; padding: 0; border: 1px solid #dce4e9; border-radius: 6px; background: #f7f9fa; color: #506273; cursor: pointer; }
.evidence-photo-preview:hover, .evidence-photo-preview:focus-visible { border-color: #409eff; outline: 2px solid rgba(64, 158, 255, .18); }
.evidence-photo-preview img, .evidence-photo-placeholder { display: flex; align-items: center; justify-content: center; width: 100%; height: 92px; object-fit: cover; }
.evidence-photo-placeholder { flex-direction: column; gap: 3px; color: #84929e; }
.evidence-photo-placeholder i { font-size: 20px; }
.evidence-photo-placeholder small { font-size: 11px; }
.evidence-photo-label { box-sizing: border-box; width: 100%; padding: 5px 6px; overflow: hidden; background: #fff; font-size: 11px; line-height: 17px; text-align: center; text-overflow: ellipsis; white-space: nowrap; }
.evidence-photo-remove { position: absolute; top: -7px; right: -7px; width: 22px; height: 22px; padding: 0; border: 0; border-radius: 50%; background: #e65656; color: #fff; font-size: 18px; line-height: 20px; cursor: pointer; }
.evidence-photo-remove:hover, .evidence-photo-remove:focus-visible { background: #c93e3e; outline: 2px solid #fff; }
</style>
